import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../../_actions/matchesActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../UserWidgetContainer";
import Section from "../../UI/Section";
import PageSubTitle from "../../UI/PageSubTitle";
import getLiked from "../../../_selectors/matchesSelectors/getLiked";
import { updateObject } from "../../../_utils";
import matchesConstants from "../../../_constants/matchesConstants";
import getMatchesLastResult from "../../../_selectors/matchesSelectors/getMatchesLastResult";
import HoverWidget from "../../UI/HoverWidget";
class Liked extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getLiked } = this.props;
    updateHeader({
      title: "Liked Members",
      description: "Members that you liked"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Matches", link: "/matches" },
      { label: "Liked Members", link: "/search" }
    ]);
    getLiked();
  }
  componentWillUnmount() {
    const { clearMembers, clearLiked } = this.props;
    clearMembers();
    clearLiked();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section white={results.length === 0}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you liked"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getLiked(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getLiked: () => dispatch(matchesActions.getLikedMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearLiked: () => dispatch(matchesActions.clearLikedMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_LIKED_MEMBERS })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Liked);



// WEBPACK FOOTER //
// ./src/_components/Matches/Liked/index.js